import {
  type exteriorType,
  type phaseType,
  type specialtyType,
  SkinProperties,
} from '../constants/skinPropertes'

// TODO: update props when integrating with apis
// used to fetch skin image from steam
export const getSkinSteamMarketHashName = (
  itemName: string,
  skinName?: string,
  exterior?: exteriorType,
  specialty?: specialtyType,
  // TODO: no idea whether will use
  phase?: phaseType,
  category?: string,
  tag?: string,
) => {
  const names = []
  // handle specialty
  if (specialty && SkinProperties.specialty[specialty]) {
    names.push(SkinProperties.specialty[specialty])
  }
  // handle item name
  names.push(itemName)
  // handle skin name
  if (skinName) {
    names.push(skinName)
  }
  // handle phase
  if (phase && SkinProperties.phase[phase]) {
    names.push(SkinProperties.phase[phase])
  }
  let steamMarketHashName = names.join(' | ')
  // handle exterior
  if (exterior && SkinProperties.exterior[exterior]) {
    steamMarketHashName += ` (${SkinProperties.exterior[exterior]})`
  }

  return steamMarketHashName
}
